import ReactHtmlParser from "html-react-parser";

export function htmlParser(html) {
  if (!html) return "";
  return ReactHtmlParser(html);
}

export function getCheckoutTotalWithFee(checkoutData, methodName) {
  if (!checkoutData) return null;
  const methodKey = methodName?.toLowerCase();
  const methodObj = checkoutData?.[methodKey];
  const methodTotalWithFee = methodObj?.gateway_fee?.total_with_fee;
  if (methodTotalWithFee != null) return methodTotalWithFee;
  return checkoutData?.total_amount ?? checkoutData?.total_price ?? null;
}

export function getPlatformFee(baseAmount) {
  const fixed = Number(process.env.REACT_APP_PLATFORM_FEE_FIXED || 0);
  const percent = Number(process.env.REACT_APP_PLATFORM_FEE_PERCENT || 0);
  const fee = (Number(baseAmount || 0) * (percent / 100)) + fixed;
  return Number(fee.toFixed(2));
}

export function formatGBP(number) {
  const formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  });
  return formatter.format(Number(number || 0));
}

export function getGatewayFeeAmount(checkoutData, methodName) {
  if (!checkoutData || !methodName) return null;
  const methodKey = methodName.toLowerCase();
  const fee = checkoutData?.[methodKey]?.gateway_fee?.fee_amount;
  if (typeof fee === "number") return fee;
  const feeNum = Number(fee);
  return isNaN(feeNum) ? null : feeNum;
}